__turbopack_context__.v({
  "component": "style-module-scss-module__Rx2_1W__component",
  "label": "style-module-scss-module__Rx2_1W__label",
  "select": "style-module-scss-module__Rx2_1W__select",
  "wrong": "style-module-scss-module__Rx2_1W__wrong",
});
